import React from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useDetailDietaryQuery } from "../../../../store/services/DietaryPreferences";
import moment from "moment";

const DietaryDetail = () => {
  const { id } = useParams();
  const { data, error, isLoading } = useDetailDietaryQuery(id);

  return (
    <section className="userDetail py-3 position-relative">
      <Container>
        <Row>
          <Col lg="12">
            <div className="d-flex align-items-center gap-10">
              <Link
                to="/manage-dietary"
                className="border d-flex align-items-center p-2 rounded"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 10 16"
                  fill="none"
                >
                  <path
                    d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    strokeWidth="0.2"
                  />
                </svg>
              </Link>
              <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                Dietary Preference Detail
              </h4>
            </div>
          </Col>

          <Col lg="12" className="my-2">
            <div
              className="formWrapper px-lg-5 p-md-4 p-3 rounded"
              style={{ background: "#EEEEEE" }}
            >
              {isLoading ? (
                <div className="text-center">
                  <Spinner animation="border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </Spinner>
                </div>
              ) : error ? (
                <div className="text-center text-danger">
                  Error loading details.
                </div>
              ) : (
                <Row>
                  <Col lg="6">
                    <p className="m-0 fw-bold">Name:</p>
                    <p>{data?.data?.name}</p>
                  </Col>
                  <Col lg="6">
                    <p className="m-0 fw-bold">Created At:</p>
                    <p>{moment(data?.data?.createdAt).format("DD/MM/YYYY")}</p>
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DietaryDetail;
